var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 13.3125H4.375C2.5 13.3125 1.25 12.375 1.25 10.1875V5.8125C1.25 3.625 2.5 2.6875 4.375 2.6875H10.625C12.5 2.6875 13.75 3.625 13.75 5.8125V10.1875C13.75 12.375 12.5 13.3125 10.625 13.3125Z",
    stroke: "#070708",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 6.125L8.66875 7.6875C8.025 8.2 6.96875 8.2 6.325 7.6875L4.375 6.125",
    stroke: "#070708",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.f77970f43c4a8c935bfb8117cf72851c.svg";
export { ForwardRef as ReactComponent };